class Headers {
  constructor() {
    this[`Content-Type`] = "application/json";
  }
}

export default new Headers();
